module.exports = __webpack_public_path__ + "static/img/m_global_article_default@3x.0214b67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_global_article_default@3x.png
// module id = ocCs
// module chunks = 1